// Action types for assigning a permission to a role
export const ASSIGN_PERMISSION_TO_ROLE_REQUEST = 'ASSIGN_PERMISSION_TO_ROLE_REQUEST';
export const ASSIGN_PERMISSION_TO_ROLE_SUCCESS = 'ASSIGN_PERMISSION_TO_ROLE_SUCCESS';
export const ASSIGN_PERMISSION_TO_ROLE_FAILURE = 'ASSIGN_PERMISSION_TO_ROLE_FAILURE';
export const CLEAR_PERMISSION_ASSIGNMENT_ERROR = 'CLEAR_PERMISSION_ASSIGNMENT_ERROR';



// Action types for fetching permissions that have been assigned to a role
export const FETCH_ASSIGNED_PERMISSIONS_REQUEST = 'FETCH_ASSIGNED_PERMISSIONS_REQUEST';
export const FETCH_ASSIGNED_PERMISSIONS_SUCCESS = 'FETCH_ASSIGNED_PERMISSIONS_SUCCESS';
export const FETCH_ASSIGNED_PERMISSIONS_FAILURE = 'FETCH_ASSIGNED_PERMISSIONS_FAILURE';
export const CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR = 'CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR';




// Action types for fetching all permissions
export const FETCH_ALL_PERMISSIONS_REQUEST = 'FETCH_ALL_PERMISSIONS_REQUEST';
export const FETCH_ALL_PERMISSIONS_SUCCESS = 'FETCH_ALL_PERMISSIONS_SUCCESS';
export const FETCH_ALL_PERMISSIONS_FAILURE = 'FETCH_ALL_PERMISSIONS_FAILURE';
export const CLEAR_PERMISSIONS_FETCHING_ERROR = 'CLEAR_PERMISSIONS_FETCHING_ERROR';



// Action types for fetching all permission categories
export const FETCH_ALL_PERMISSION_CATEGORIES_REQUEST = 'FETCH_ALL_PERMISSION_CATEGORIES_REQUEST';
export const FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS = 'FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS';
export const FETCH_ALL_PERMISSION_CATEGORIES_FAILURE = 'FETCH_ALL_PERMISSION_CATEGORIES_FAILURE';
export const CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR = 'CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR';




// Action types for fetching role permissions
export const FETCH_ROLE_PERMISSIONS_REQUEST = 'FETCH_ROLE_PERMISSIONS_REQUEST';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAILURE = 'FETCH_ROLE_PERMISSIONS_FAILURE'
export const CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR = 'CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR';




// Action types for removing a permission from a role
export const REMOVE_PERMISSION_FROM_ROLE_REQUEST = 'REMOVE_PERMISSION_FROM_ROLE_REQUEST';
export const REMOVE_PERMISSION_FROM_ROLE_SUCCESS = 'REMOVE_PERMISSION_FROM_ROLE_SUCCESS';
export const REMOVE_PERMISSION_FROM_ROLE_FAILURE = 'REMOVE_PERMISSION_FROM_ROLE_FAILURE';
export const CLEAR_PERMISSION_REMOVAL_ERROR = 'CLEAR_PERMISSION_REMOVAL_ERROR';

